import SessionStorageService from '@/services/SessionStorageService'

export default function authenticated ({ next, router }) {
    const service = new SessionStorageService()
    if (!service.getByKey('logged_in')) {
        return router.replace({ name: 'Login' })
    }

    return next()
}



// WEBPACK FOOTER //
// ./src/middleware/Authenticated.js